import { render, staticRenderFns } from "./AcikAlimSiparisleri.vue?vue&type=template&id=57be5746"
import script from "./AcikAlimSiparisleri.vue?vue&type=script&lang=js"
export * from "./AcikAlimSiparisleri.vue?vue&type=script&lang=js"
import style0 from "./AcikAlimSiparisleri.vue?vue&type=style&index=0&id=57be5746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports